import { useMemo } from "react"
import { BracketHoldingsStats } from "./BracketHoldingsStats"
import { generateHoldingData } from "./utils/outcome-stats-utils"

interface BracketCardOutcomeStatsProps {
  isExpanded: boolean
  outcomeName: string
  volume?: number | undefined
  change24h?: number | undefined
  marketCap?: number | undefined
  holders?: number | undefined
  lastTrade?: string | undefined
  shares?: number | undefined
  maxWinAmount?: number | undefined
  heldOutcomes?: string[] | undefined
  outcomeSlug?: string | undefined
}

export function BracketCardOutcomeStats({
  isExpanded,
  outcomeName,
  volume: _propVolume,
  change24h: _propChange24h,
  marketCap: _propMarketCap,
  holders: _propHolders,
  lastTrade: _propLastTrade,
  shares,
  maxWinAmount,
  heldOutcomes = [],
  outcomeSlug,
}: BracketCardOutcomeStatsProps) {
  // Stats generation (unused but kept for future use)
  // const stats = useMemo(() => {
  //   const generated = generateSeededStats(outcomeName)
  //   return {
  //     volume: propVolume ?? generated.volume,
  //     change24h: propChange24h ?? generated.change24h,
  //     marketCap: propMarketCap ?? generated.marketCap,
  //     holders: propHolders ?? generated.holders,
  //     lastTrade: propLastTrade ?? generated.lastTrade,
  //   }
  // }, [outcomeName, propVolume, propChange24h, propMarketCap, propHolders, propLastTrade])

  const userHoldsThisOutcome = outcomeSlug ? heldOutcomes.includes(outcomeSlug) : false

  const simulatedHoldingData = useMemo(() => {
    if (!(userHoldsThisOutcome && outcomeSlug)) return null
    return generateHoldingData(outcomeName, outcomeSlug, shares, maxWinAmount)
  }, [userHoldsThisOutcome, outcomeName, outcomeSlug, shares, maxWinAmount])

  return (
    <BracketHoldingsStats
      isExpanded={isExpanded}
      shares={userHoldsThisOutcome && simulatedHoldingData ? simulatedHoldingData.shares : undefined}
      maxWinAmount={userHoldsThisOutcome && simulatedHoldingData ? simulatedHoldingData.maxWinAmount : undefined}
    />
  )
}
